import { createAction, PrepareAction } from '@reduxjs/toolkit';

import reducer from './reducer';

export const prepareFinalize:PrepareAction<{ time?: number, shouldReset?: boolean }> = (time, shouldReset) => ({
  payload: {
    time,
    shouldReset,
  },
});

export const finalizeSelfService = createAction('SELF_SERVICE/FINALIZE', prepareFinalize);

export const { openFlowTypeModal, resetFlowType, setFlowType, setIsAdditionalCustomerDriving } = reducer.actions;
